// config.js (frontend)

//
// ⚙️ Gestion intelligente de l'URL API pour tous les environnements :
// - Localhost (développement local)
// - Tunnel Cloudflare (HTTPS public)
// - Production (même domaine que le front)
//

// Fonction principale
export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // 1️⃣ Priorité à la variable d'environnement (.env)
  if (envUrl) {
    //console.log('🌐 Utilisation de REACT_APP_API_URL:', envUrl);
    return envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
  }

  // 2️⃣ Environnement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000/api';
  }

  // 3️⃣ Tunnel Cloudflare ou domaine distant (HTTPS requis)
  //    Exemple : https://xxxxx.trycloudflare.com/api
  return `${protocol}//${hostname}/api`;
};

// URL de base
export const API_BASE_URL = getApiUrl();

// 🚀 Log d'information (utile pour vérifier dans la console du navigateur)
//console.log('🔧 API_BASE_URL configurée sur:', API_BASE_URL);
/*console.log('🔍 Type d’accès détecté:', {
  isLocal: API_BASE_URL.includes('localhost'),
  isTunnel: API_BASE_URL.includes('trycloudflare'),
  isIP: /\d+\.\d+\.\d+\.\d+/.test(API_BASE_URL)
});
*/
// Export standard
export default {
  API_BASE_URL
};
